import breakpoints from './breakpoints';
import { newPalettes, TenantPalette } from './newPalette';

// make font size responsive
interface responsiveFontType {
    sm?: object;
    lg?: object;
}
export function responsiveFontSizes({ sm, lg }: responsiveFontType) {
    return {
        [`@media (max-width: ${breakpoints.values.lg}px)`]: lg,
        [`@media (max-width: ${breakpoints.values.sm}px)`]: sm
    };
}

export const getJsonValues = (obj: any): any[] => {
    return Object.values(obj)
        .map((value) => (typeof value === 'object' && value !== null ? getJsonValues(value) : value))
        .flat();
};

export const validateThemeJSON = (JSONString: string) => {
    try {
        const parsed_json = JSON.parse(JSONString);
        const sample_json = newPalettes?.advice;

        if (!sample_json) {
            console.error('Sample palette (newPalettes.advice) is not available');
            return false;
        }

        const requiredKeys = Object.keys(sample_json);

        // Check if all required keys are present
        const missingKeys = requiredKeys.filter((key) => !(key in parsed_json));

        if (missingKeys.length > 0) {
            console.error('Missing required keys:', missingKeys);
            return false;
        }

        // Validate structure for each key dynamically based on sample_json
        for (const key of requiredKeys) {
            const sampleValue = sample_json[key as keyof TenantPalette];
            const parsedValue = parsed_json[key];

            // Check if the type matches
            if (typeof sampleValue !== typeof parsedValue) {
                console.error(
                    `Type mismatch for key '${key}': expected ${typeof sampleValue}, got ${typeof parsedValue}`
                );
                return false;
            }

            // If the sample value is an object, validate nested structure
            if (typeof sampleValue === 'object' && sampleValue !== null) {
                if (typeof parsedValue !== 'object' || parsedValue === null) {
                    console.error(`Invalid structure for key: ${key}`);
                    return false;
                }

                // Check for nested keys
                const requiredNestedKeys = Object.keys(sampleValue);
                const missingNestedKeys = requiredNestedKeys.filter((nestedKey) => !(nestedKey in parsedValue));

                if (missingNestedKeys.length > 0) {
                    console.error(`Missing required nested keys in '${key}':`, missingNestedKeys);
                    return false;
                }
            }
        }

        // validate value with regex for color codes
        const colorCodeRegex =
            /^#([0-9A-Fa-f]{3}){1,2}$|^rgba?\(\s*(\d{1,3}\s*,\s*){2}\d{1,3}(\s*,\s*(0|0?\.\d+|1(\.0)?))?\s*\)$/;
        const parsedValues = getJsonValues(parsed_json);
        for (const value of parsedValues) {
            if (typeof value === 'string' && !colorCodeRegex.test(value)) {
                console.error(`Invalid color code value: ${value}`);
                return false;
            }
        }

        return true;
    } catch (e) {
        console.error('JSON parsing error:', e);
        return false;
    }
};
